import { render } from "./ObservacionesReportes.vue?vue&type=template&id=113d6842&scoped=true"
import script from "./ObservacionesReportes.vue?vue&type=script&lang=js"
export * from "./ObservacionesReportes.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=113d6842&scoped=true&lang=css"
import "./ObservacionesReportes.vue?vue&type=style&index=1&id=113d6842&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113d6842"]])

export default __exports__